<!--
 * @Author: mojiangpeng 125392435@qq.com
 * @Date: 2022-06-17 10:51:25
 * @LastEditors: mojiangpeng 125392435@qq.com
 * @LastEditTime: 2022-08-23 14:15:22
 * @FilePath: \Mobile-FE\src\views\user\report\Info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="container">
    <head-nav-bar
      title="检查报告明细"
      :fixed="true"
      @click-left="onLeftClick"
    />
    <div class="mt-header-nav">
      <div class="box">
        <cell-box style="padding: 0.3rem 0;">
          <!-- <cell-item label="订单编号：" :value="info.BillNo" /> -->
          <cell-item label="姓名：" :value="info.patientName" />
          <cell-item label="性别：" :value="info.patientSex" />
          <cell-item label="年龄：" :value="info.patientAge" />
          <cell-item label="检查所见：">
            <template #value>
              <div style="color:#888">{{ info.indication }}</div>
            </template>
          </cell-item>
          <cell-item label="诊断意见：">
            <template #value>
              <div style="color:#888">{{ info.diagnose }}</div>
            </template>
          </cell-item>

          <cell-item label="检查时间：" :value="info.examTime" />
          <cell-item label="报告医生：" :value="info.reportDoctor" />
          <cell-item label="报告时间：" :value="info.reportTime" />
          <cell-item label="审核医生：" :value="info.auditDoctor" />
          <cell-item label="审核时间：" :value="info.auditTime" />
        </cell-box>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Icon, NoticeBar } from "vant";
import { CellBox, CellItem } from "@/components/cell";

export default {
  name: "userReportInfo",
  components: {
    CellBox,
    CellItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
  },

  data() {
    return {
      Id: "",
      ReqNo: "",
      type: 1,
      info: {},
      canCancel: false,
      DiagnosisCardNo: "",
      InpatientId: "",
    };
  },
  created() {
    this.Id = this.$route.query.Id;
    this.ReqNo = this.$route.query.ReqNo;
    this.type = this.$route.query.type;
    this.DiagnosisCardNo = this.$route.query.DiagnosisCardNo;
    this.InpatientId = this.$route.query.InpatientId;
    if (this.Id && this.ReqNo) {
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.$post("MyReport_Detail", {
        ReportId: this.Id,
        ReqNo: this.ReqNo,
      }).then(res => {
        this.info = res.data;
      });
    },
    onLeftClick() {
      this.$router.push({
        name: "userInHospitalizationReport",
        query: {
          tab: this.type,
          DiagnosisCardNo: this.DiagnosisCardNo,
          InpatientId: this.InpatientId,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
